import { Component, Input } from '@angular/core';
import { IMAGE_SRC } from 'src/app/components/shared/shared-constants';
import { STOP_TYPE_ABB } from 'src/app/core/enums/operations.enum';
import { TableOperationsRouteDetails } from 'src/app/core/models/operations/operations-route-details.model';
import { EDIT_STOP_CONSTANTS } from '../edit-operations-stop.constants';

@Component({
  selector: 'app-edit-stop-left-section',
  templateUrl: './edit-stop-left-section.component.html',
  styleUrls: ['./edit-stop-left-section.component.scss'],
  standalone: false,
})
export class EditStopLeftSectionComponent {
  readonly CONSTANTS = EDIT_STOP_CONSTANTS;
  readonly STOP_TYPES = STOP_TYPE_ABB;
  readonly SRC = IMAGE_SRC;

  @Input() data!: TableOperationsRouteDetails[];
  @Input() viewIndex?: number;
}
